export enum RoutePath {
  Home = '/',
  PrivacyPolicy = '/politica-de-privacidade',
  NoMatch = '*',
}
